import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../helpers/value'
import { selectData } from '../store/slice'

export const AvailableData = () => {
  const data = useSelector(selectData)

  return (
    <div className="dFlex alignItemsCenter">
      <span className="mr1">
        <Translate value="common.order.factSheet.AVAILABLE_DATA" />:
      </span>
      <span>{formatText(data.availableData)}</span>
    </div>
  )
}
